export default __webpack_public_path__ + "static/media/recyclebk.53c72151.png";